import { LOCALES } from 'i18n/locales';

export const saveObservationPageIntl = {
    [LOCALES.ENGLISH]: {
        'saveObservationPage.newTitle': 'Create observation',
        'saveObservationPage.editTitle': 'Edit observation',
        'saveObservationPage.observationLocation': 'Observation coordinates: ',
        'saveObservationPage.mapPreview.title': 'Location data',
        'saveObservationPage.displayTitle': 'Observation title',
        'saveObservationPage.titleDescription': 'This will be used as the title for this observation when displayed in your account',
        'saveObservationPage.chooseCategory': 'Choose a category',
        'saveObservationPage.observationCategory': 'Observation category',
        'saveObservationPage.description': 'Description',
        'saveObservationPage.descriptionDescription': 'Provide a description of the observation',
        'saveObservationPage.createButton.label': 'Create observation',
        'saveObservationPage.saveButton.label': 'Save observation',
        'saveObservationPage.cannotBeEmpty': 'This cannot be empty',
        'saveObservationPage.tooLong': 'This is too long',
        'saveObservationPage.correctErrors': 'Please correct the errors above before submitting',
        'saveObservationPage.editButton': 'Edit location'
    },
    [LOCALES.WELSH]: {
        'saveObservationPage.newTitle': 'Creu Arsylwad',
        'saveObservationPage.editTitle': 'Golygu Arsylwad',
        'saveObservationPage.observationLocation': 'Cyfesurynnau arsylwad',
        'saveObservationPage.mapPreview.title': 'Data lleoliad',
        'saveObservationPage.displayTitle': 'Teitl arsylwad',
        'saveObservationPage.titleDescription': 'Bydd hwn yn cael ei ddefnyddio fel teitl ar gyfer yr arsylwad hwn pan gaiff ei arddangos yn eich cyfrif',
        'saveObservationPage.chooseCategory': 'Dewis categori',
        'saveObservationPage.observationCategory': 'Categori\'r arsylwad',
        'saveObservationPage.description': 'Disgrifiad',
        'saveObservationPage.descriptionDescription': 'Darparu disgrifiad o\'r arsylwad',
        'saveObservationPage.createButton.label': 'Creu arsylwad',
        'saveObservationPage.saveButton.label': 'Cadw arsylwad',
        'saveObservationPage.cannotBeEmpty': 'Ni all hwn fod yn wag',
        'saveObservationPage.tooLong': 'Mae hwn yn rhy hir',
        'saveObservationPage.correctErrors': 'Cywirwch y gwallau uchod cyn cyflwyno',
        'saveObservationPage.editButton': 'Golygu lleoliad'
    }
};
